<template>
    <div class="tab-toggle d-flex align-items-center py-5 pl-5 pr-3 text-lg" :class="{'selected': current}" @click="openRelatedTab">
        <slot></slot>

        <span class="icon-right-open-big pl-5 ml-auto"></span>
    </div>
    
</template>

<script>
    export default {
        props: {
            for: {type: String, required: true},
            mobile: Boolean,
            selected: Boolean,
        },

        data: function () {
            return {
                current: this.mobile ? false : this.selected,
                isMobile: false,
            }
        },

        created: function () {
            bus.$on('tab-content-open', ( id, mobile, slotText ) => {
                this.current = this.for == id;
            });
        },

        mounted: function () {
            this.checkMobile();
            
            if(window.location.href.indexOf(`#${this.for}`) > -1) this.openRelatedTab();

            if (this.selected && !this.isMobile ) this.openRelatedTab();
        },

        methods: {
            openRelatedTab: function () {
                this.checkMobile();

                bus.$emit('tab-content-open', this.for, this.isMobile, this.$slots.default[0].text );
            },
            checkMobile: function () {
                this.isMobile = this.mobile && $(window).width() < 768;
            },
        }
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    .tab-toggle{
        background-color: #fbfbfb;
        border: .1rem solid $gray-lightest;
        color: $gray-darker;
        cursor: default;

        &:hover{
            color: black;
        }

        &.selected{
            background-color: $white;
            color: $green-light;
        }

        + .tab-toggle{
            border-top: none;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TabToggle.vue